import { format } from 'date-fns'

import { TimeFormat } from '../../models'

export const formatHour = (hour: number): string => format(new Date().setHours(hour, 0, 0, 0), TimeFormat.Numeric)
